import { AppUserRole, ShelterRosterRole } from '../constants/appUserRole';

export function isSuperAdmin(role: AppUserRole): boolean {
  return role === AppUserRole.SUPER_ADMIN;
}

export function isShelterAdministrator(
  role: AppUserRole,
  shelterRole?: ShelterRosterRole,
): boolean {
  if (role === AppUserRole.SHELTER_ADMIN) return true;
  return (
    role === AppUserRole.USER && shelterRole === ShelterRosterRole.ADMIN
  );
}

export function isShelterAdmin(
  shelterId: string | undefined,
  shelterRole: ShelterRosterRole | undefined,
): boolean {
  return Boolean(shelterId && shelterRole === ShelterRosterRole.ADMIN);
}

export function isShelterMember(shelterId: string | undefined): boolean {
  return Boolean(shelterId);
}
